import { newAxiosIns } from '@/libs/axios'

export function apiGetAgentList() {
  return newAxiosIns.get('komchat-api/api/v1/agent')
}

export function apiDeleteAgent(id) {
  return newAxiosIns.delete(`komchat-api/api/v1/agent/${id}`)
}

export function apiCreateAgent(data) {
  return newAxiosIns.post('komchat-api/api/v1/agent', data)
}

export function apiUpdateAgent(id, data) {
  return newAxiosIns.put(`komchat-api/api/v1/agent/${id}`, data)
}

export function apiGetAgentDetail(id) {
  return newAxiosIns.get(`komchat-api/api/v1/agent/${id}`)
}

export function apiActivateAgent(id, isActive) {
  return newAxiosIns.put(`komchat-api/api/v1/agent/${id}/change_active`, { is_active: isActive })
}
